export default __webpack_public_path__ + "static/media/BH.aa2c1531.png";